import { render, staticRenderFns } from "./classChart.vue?vue&type=template&id=31caaa86&scoped=true&"
import script from "./classChart.vue?vue&type=script&lang=js&"
export * from "./classChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31caaa86",
  null
  
)

export default component.exports